import { Outlet } from 'react-router-dom';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
// components
import Header from './Header';
import { ThemeProvider } from '@mui/material/styles';
import { createCustomTheme } from 'src/theme/createCustomTheme';
import { useLayout } from 'src/contexts/LayoutContext';

// ----------------------------------------------------------------------

export default function RelationalLayout({ children }: { children?: React.ReactNode }) {
  const { headerLayout } = useLayout();

  const isOffset = useOffSetTop(headerLayout.H_MAIN_DESKTOP);
  const customTheme = createCustomTheme('default');

  return (
    <ThemeProvider theme={customTheme}>
      <Header isOffset={isOffset} />

      <Outlet />

      {children}
    </ThemeProvider>
  );
}
